import { ACTIVITY_OBJECTS } from '../../hooks/useObjectTypeSelect';
import { useStrategy } from '../../hooks/useStrategy';
import FormattedList from 'I18n/components/FormattedList';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ActivityFilterInfoTooltip = ({
  children,
  disabled,
  listActivityObjects
}) => {
  const {
    getFilterFamilyObjectName
  } = useStrategy();
  return /*#__PURE__*/_jsx(Tooltip, {
    disabled: disabled,
    placement: "right",
    title: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "newCustomerDataFilters.activityFilterInfo.description"
      }), listActivityObjects && /*#__PURE__*/_jsxs(View, {
        marginBlockStart: "300",
        as: "div",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "newCustomerDataFilters.activityFilterInfo.availableActivityTypes"
        }), ' ', /*#__PURE__*/_jsx(FormattedList, {
          children: ACTIVITY_OBJECTS.map(objectTypeId => /*#__PURE__*/_jsx("span", {
            children: getFilterFamilyObjectName(objectTypeId)
          }, `activity-object-type-${objectTypeId}`))
        })]
      })]
    }),
    use: "longform",
    children: /*#__PURE__*/_jsx("span", {
      children: children
    })
  });
};
export default ActivityFilterInfoTooltip;